import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { currentLanguage } = useTranslation();
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8FAFB] p-6 text-center">
      <Helmet>
        <title>404 - Página Não Encontrada | PROVATIO</title>
      </Helmet>
      
      <div className="w-24 h-24 rounded-full border-4 border-[#D4AF37] flex items-center justify-center mb-8 bg-white shadow-xl">
        <AlertTriangle className="w-12 h-12 text-[#D4AF37]" />
      </div>
      
      <h1 className="text-7xl md:text-9xl font-black mb-4 text-[#193D6D]">
        404
      </h1>
      
      <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6">
        Página não encontrada
      </h2>
      
      <p className="text-lg text-slate-600 max-w-lg mb-10">
        O conteúdo que você está tentando acessar não existe, foi movido ou o link está quebrado.
      </p>
      
      <button 
        onClick={() => navigate(`/${currentLanguage}`)}
        className="flex items-center gap-3 px-8 py-4 bg-[#193D6D] text-white font-bold rounded-lg hover:bg-[#122b4d] hover:-translate-y-1 transition-all duration-300 shadow-md"
      >
        <Home className="w-5 h-5 text-[#D4AF37]" />
        Retornar à Página Inicial
      </button>
    </div>
  );
}